import Box from "@storeblocks/box";
import styled from "styled-components";

export const IconWrapper = styled(Box)`
  display: flex;
  height: 50px;
  margin-right: 12px;
  width: 50px;

  svg {
    height: 50px;
    width: 50px;
  }
`;

export const CardContent = styled.div`
  padding-left: 14px;
`;

export const Title = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.md};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  line-height: ${({ theme }) => theme.lineHeight.md};
`;

export const DescriptionWrapper = styled.div`
  margin-top: 0;
`;

export const Description = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  line-height: ${({ theme }) => theme.lineHeight.md};
`;
